import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import KpiTable from "../views/kpi/KpiTable.vue";
import { useAuthStatus } from "@/composables/useAuthStatus";
import authRoutes from "./authRoutes";
import contractRoutes from "./contractRoutes";
import plannerRoutes from "./plannerRoutes";
import messageRoutes from "./messageRoutes";
const routes = [
    ...authRoutes,
    ...contractRoutes,
    ...plannerRoutes,
    ...messageRoutes,
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/kpi",
        name: "KpiTable",
        component: KpiTable,
    },
    {
        path: "/kpi/engagement",
        name: "EngagementKPI",
        component: () => import("../views/kpi/Engagement.vue"),
    },
    {
        path: "/invoice",
        name: "Invoice",
        component: () => import("../views/Invoice.vue"),
    },
    {
        path: "/bulkMessage",
        name: "BulkMessage",
        component: () => import("../views/BulkMessage.vue"),
    }
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});
router.beforeEach(async (to, from, next) => {
    // 認証状態をチェック
    const { isLoggedIn, checkAuthStatus } = useAuthStatus();
    await checkAuthStatus(); // 認証状態をAPIに問い合わせ
    // meta.public が付いた画面だけがログイン不要。印の付け忘れ・書き間違いは
    // 「ログイン必須」側に倒れる。一致するルートが無い URL も同じ扱いになる。
    // 判定は一致した末端のルートだけを見るので、公開の親ルートを足しても
    // その子は自動的には公開にならない。
    const matchedRoute = to.matched[to.matched.length - 1];
    const isPublic = matchedRoute?.meta.public === true;
    if (to.name === "Login" && isLoggedIn.value) {
        // ログインページへのアクセスで既にログインしている場合はホームにリダイレクト
        next({ name: "Home" });
    }
    else if (!isPublic && !isLoggedIn.value) {
        // ログインが必要なページへのアクセスでログインしていない場合はログインページにリダイレクト
        next({ name: "Login" });
    }
    else {
        // それ以外の場合は、ナビゲーションをそのまま進める
        next();
    }
});
export default router;
